import { Component, OnInit } from '@angular/core';
import { Data, DataLoaderService, ProgressBarService, AlternateOptionsService, CommonDataService, Subscription, PriceCalculationService } from '../index'
import { SummaryService } from "../selectable-tabs/normal-screen-components/service-call-index";
@Component({
	selector: '[technical-data]',
	templateUrl: './technical-data.template.html',
	styleUrls: ['./technical-data.component.css'],
})
export class TechnicalData {
	public technicalData: Data[];
	public currency: string;
	public technicalOptionsSuggList = [];
	public selectedTechnicalOptions: Data[] = [];
	public flag: boolean = false;

	private subscription: Subscription;
	public errMessage;
	constructor(private dataLoaderService: DataLoaderService, private progressService: ProgressBarService,
		private alternateOptionsService: AlternateOptionsService, private commonDataService: CommonDataService,
		private priceCalculationService: PriceCalculationService, private summaryService: SummaryService) {
		this.currency = this.dataLoaderService.data.currencyType;
		this.technicalData = this.dataLoaderService.data.technicalDataItems;
	}

	ngOnInit() {
	}
}



// WEBPACK FOOTER //
// ./src/app/components/technical-data/technical-data.component.ts